<template>
    <div class="col-md-12">   
        <KTCard v-bind:title="page_title">
            <template v-slot:body>
                <div class="d-flex flex-column flex-root">
                    <div
                        class="error error-6 d-flex flex-row-fluid bgi-size-cover bgi-position-center"
                        
                    >
                        <!-- begin:: Content -->
                        <div class="d-flex flex-column flex-row-fluid text-center justify-content-center align-items-center">
                            <h1
                                class="error-title font-weight-boldest mb-12"
                            >
                                Dikkat...
                            </h1>
                            <p class="display-4 font-weight-bold">
                                Sistemde fotoğrafınız bulunamadı.  
                                <br />Lütfen profilime gidip fotoğrafınızı yükleyiniz.
                            </p>
                            <p>
                                <b-button
                                    size="lg"
                                    variant="success"
                                    @click="goToProfilePage"
                                >
                                <i class="la la-user"></i>
                                    Profilime Git
                                </b-button>
                            </p>
                        </div>
                        <!-- end:: Content -->
                    </div>
                </div>
            </template>
        </KTCard>
    </div>
</template>


<script>
import KTCard from "@/view/content/Card.vue";
export default {
    name: "credit-balance",
    data() {
        return {
            page_title: 'Fotoğraf Bulunamadı...',
        };
    },
   
    mounted() {},
    methods: {
        goToProfilePage() {
            this.$router.push({name: 'my-profile'});
        },
    },
    components: {
        KTCard,
        //Multiselect
    },

};
</script>
